import Typography from "@material-ui/core/Typography";
import React from "react";
import { IncompleteType } from "@prestosports/prestostats-core/Tennis";
import { useMediaQuery } from "@material-ui/core";
import Box from "@material-ui/core/Box";
import Chip from "@material-ui/core/Chip";
import classnames from "classnames";
import teamStyles from "../../team/styles/Team.styles";
import { usePlayersContext } from "../../../state/players/context";
import PlayerFormat from "../../../util/player-format";
import TeamLogo from "../../team/components/TeamLogo";

const Team = ({
	team,
	textVariant,
	size,
	isWinner = false,
	playersId,
	rank,
	incompleteType
}) => {
	const firstInitial = useMediaQuery("(max-width:1180px)");
	const classes = teamStyles({ size, isWinner });

	const { state: playersState } = usePlayersContext();
	const players = team ? playersState.players(team.id) : [];
	const hiddenUniforms = [PlayerFormat.TeamUniform];
	const filteredPlayers = players.filter(
		(p) => !hiddenUniforms.includes(p.uniform)
	);

	const playersToShow = filteredPlayers.filter((p) => playersId.includes(p.id));

	const getIncompleteStatus = () => {
		const status = Object.values(IncompleteType).find((o) =>
			o.equals(incompleteType)
		);
		if (status) {
			return status.name.toUpperCase();
		}

		return null;
	};

	return (
		<Box display="flex" alignItems="center">
			<TeamLogo size="small" hideName team={team} />
			<Typography variant={textVariant} className={classes.teamName}>
				{playersToShow
					.map((player) =>
						PlayerFormat.resolveTennisPlayerName(player, firstInitial)
					)
					.join(" / ")}
				{rank && ` (${rank})`}
				{incompleteType && (
					<Box m={1} display="inline">
						<Chip
							color="primary"
							variant="outlined"
							size="small"
							label={getIncompleteStatus()}
							className={classnames(classes.chipSquared, classes.incompleteStatus)}
						/>
					</Box>
				)}
			</Typography>
		</Box>
	);
};

export default Team;
